import { megabytesToBytes } from "shared/helpers/bytesConverter";

export const VALUES = {
  fileUploadMaxSize: megabytesToBytes(5),
};
